// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import ManageProducts from "layouts/manageProducts";
import OrderManagement from "layouts/orderManagement";
import ReturnExchangeManagement from "layouts/returnExchange";

// @mui icons
import Icon from "@mui/material/Icon";
import AddProducts from "layouts/manageProducts/add";
import ManageQuotes from "layouts/manageQuotes";
import VerifyOtp from "layouts/authentication/otp-verify";
import ProfileSetup from "layouts/authentication/profile-setup";
import ManagePayments from "layouts/managePayment";
import MessagingSystem from "layouts/messagingSystem";
import ManageReview from "layouts/manageReviews";
import ManageNotifications from "layouts/manageNotifications";
import Settings from "layouts/settings";
import ForgotPassword from "layouts/authentication/forgotPassword";
import ResetPassword from "layouts/authentication/resetPassword";
import Analytics from "layouts/analytics";
import ManageDiscount from "layouts/manageDiscount";
import AddDiscount from "layouts/manageDiscount/add";
import EditProfile from "layouts/editProfile";
import ProductDetails from "layouts/manageProducts/details";
import OrderDetails from "layouts/orderManagement/details";
import DiscountDetails from "layouts/manageDiscount/details";
import QuoteChat from "layouts/manageQuotes/quoteChat";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import ReturnExchangeDetails from "layouts/returnExchange/details";
import Notifications from "layouts/notifications";
import Agreement from "layouts/authentication/agreement";
import useTranslation from "hooks/Translation";
import { getFromStorage } from "helpers";
import { STORAGE_KEYS } from "helpers";
import Terms from "layouts/authentication/terms";
import PrivacyPolicy from "layouts/authentication/privacyPolicy";
import About from "layouts/authentication/about";

const GetAllRoutes = () => {
  const t = useTranslation();
  const lang = getFromStorage(STORAGE_KEYS.language);
  console.log(lang);

  const routes = [
    {
      type: "collapse",
      name:
        lang === "ar"
          ? "لوحة التحكم"
          : lang === "ru"
          ? "Панель управления"
          : "Dashboard",
      key: "dashboard",
      icon: <Icon fontSize="small">dashboard</Icon>,
      route: "/dashboard",
      component: <Dashboard />,
    },
    {
      type: "collapse",
      name:
        lang === "ar"
          ? "قائمة المنتجات"
          : lang === "ru"
          ? "Список продуктов"
          : "Product Listing",
      key: "product-listing",
      icon: <Icon fontSize="small">inventory_2</Icon>,
      route: "/product-listing",
      component: <ManageProducts />,
    },
    {
      type: "collapse",
      name:
        lang === "ar"
          ? "إدارة الأسعار"
          : lang === "ru"
          ? "Управление ценами"
          : "Managing Quotes",
      key: "managing-quotes",
      icon: <Icon fontSize="small">request_quote</Icon>,
      route: "/managing-quotes",
      component: <ManageQuotes />,
    },
    {
      type: "collapse",
      name:
        lang === "ar"
          ? "إدارة الطلبات"
          : lang === "ru"
          ? "Управление заказами"
          : "Orders Management",
      key: "orders-management",
      icon: <Icon fontSize="small">list_alt_check</Icon>,
      route: "/orders-management",
      component: <OrderManagement />,
    },
    {
      type: "collapse",
      name:
        lang === "ar"
          ? "تبادل العودة"
          : lang === "ru"
          ? "Возврат и обмен"
          : "Return Exchange",
      key: "return-exchange",
      icon: <Icon fontSize="small">currency_exchange</Icon>,
      route: "/return-exchange",
      component: <ReturnExchangeManagement />,
    },
    {
      type: "collapse",
      name:
        lang === "ar"
          ? "إدارة الدفع"
          : lang === "ru"
          ? "Управление платежами"
          : "Payment Management",
      key: "payment-management",
      icon: <Icon fontSize="small">payments</Icon>,
      route: "/payment-management",
      component: <ManagePayments />,
    },

    {
      type: "collapse",
      name:
        lang === "ar"
          ? "إدارة الخصم"
          : lang === "ru"
          ? "Управление скидками"
          : "Manage Discount",
      key: "manage-discount",
      icon: <Icon fontSize="small">star</Icon>,
      route: "/manage-discount",
      component: <ManageDiscount />,
    },
    {
      type: "collapse",
      name:
        lang === "ar"
          ? "نظام المراسلة"
          : lang === "ru"
          ? "Система сообщений"
          : "Messaging System",
      key: "messaging-system",
      icon: <Icon fontSize="small">chat</Icon>,
      route: "/messaging-system",
      component: <MessagingSystem />,
    },
    {
      type: "collapse",
      name:
        lang === "ar"
          ? "التقييم والمراجعات"
          : lang === "ru"
          ? "Оценки и отзывы"
          : "Rating & Reviews",
      key: "rating-&-reviews",
      icon: <Icon fontSize="small">reviews</Icon>,
      route: "/rating-&-reviews",
      component: <ManageReview />,
    },
    {
      type: "collapse",
      name:
        lang === "ar"
          ? "التحليلات والتقارير"
          : lang === "ru"
          ? "Аналитика и отчёты"
          : "Analytics & Reports",
      key: "analytics",
      icon: <Icon fontSize="small">analytics</Icon>,
      route: "/analytics",
      component: <Analytics />,
    },

    {
      type: "collapse",
      name:
        lang === "ar"
          ? "إدارة الإخطار"
          : lang === "ru"
          ? "уведомлениями"
          : "Manage Notification",
      key: "manage-notifications",
      icon: <Icon fontSize="small">notifications</Icon>,
      route: "/manage-notifications",
      component: <ManageNotifications />,
    },
    {
      type: "collapse",
      name:
        lang === "ar" ? "حسابي" : lang === "ru" ? "Мой аккаунт" : "My Account",
      key: "my-account",
      icon: <Icon fontSize="small">account_circle</Icon>,
      route: "/my-account",
      component: <Profile />,
    },
    {
      type: "collapse",
      name:
        lang === "ar" ? "إعدادات" : lang === "ru" ? "Настройки" : "Settings",
      key: "settings",
      icon: <Icon fontSize="small">settings</Icon>,
      route: "/settings",
      component: <Settings />,
    },
    // {
    //   type: "collapse",
    //   name: "Tables",
    //   key: "tables",
    //   icon: <Icon fontSize="small">table_view</Icon>,
    //   route: "/tables",
    //   component: <Tables />,
    // },
    // {
    //   type: "collapse",
    //   name: "Billing",
    //   key: "billing",
    //   icon: <Icon fontSize="small">receipt_long</Icon>,
    //   route: "/billing",
    //   component: <Billing />,
    // },
    // {
    //   type: "collapse",
    //   name: "RTL",
    //   key: "rtl",
    //   icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
    //   route: "/rtl",
    //   component: <RTL />,
    // },
    // {
    //   type: "collapse",
    //   name: "Notifications",
    //   key: "notifications",
    //   icon: <Icon fontSize="small">notifications</Icon>,
    //   route: "/notifications",
    //   component: <Notifications />,
    // },

    {
      type: "collapse",
      name: lang === "ar" ? "تسجيل الخروج" : lang === "ru" ? "Выйти" : "Logout",
      key: "sign-in",
      icon: <Icon fontSize="small">logout</Icon>,
      route: "/authentication/sign-in",
      component: <SignIn />,
    },
    {
      name: "Sign Up",
      key: "sign-up",
      icon: <Icon fontSize="small">assignment</Icon>,
      route: "/authentication/sign-up",
      component: <SignUp />,
    },
    {
      name: "Add Products",
      key: "add-products",
      icon: <Icon fontSize="small">table_view</Icon>,
      route: "/manage-products/add",
      component: <AddProducts />,
    },
    {
      name: "Add Discount",
      key: "add-discount",
      icon: <Icon fontSize="small">table_view</Icon>,
      route: "/manage-discount/add",
      component: <AddDiscount />,
    },
    {
      name: "Edit Discount",
      key: "edit-discount",
      icon: <Icon fontSize="small">table_view</Icon>,
      route: "/manage-discount/edit/:id",
      component: <AddDiscount />,
    },
    {
      name: "Edit Products",
      key: "edit-products",
      icon: <Icon fontSize="small">table_view</Icon>,
      route: "/manage-products/:id",
      component: <AddProducts />,
    },
    {
      name: "Product Detail",
      key: "product-detail",
      icon: <Icon fontSize="small">table_view</Icon>,
      route: "/manage-products/details/:id",
      component: <ProductDetails />,
    },
    {
      name: "Order Detail",
      key: "order-detail",
      icon: <Icon fontSize="small">table_view</Icon>,
      route: "/manage-orders/details/:id",
      component: <OrderDetails />,
    },
    {
      name: "Return & Exchange Details",
      key: "return-exchange-details",
      icon: <Icon fontSize="small">table_view</Icon>,
      route: "/return-exchange/details/:id",
      component: <ReturnExchangeDetails />,
    },
    {
      name: "Discount Detail",
      key: "discount-detail",
      icon: <Icon fontSize="small">table_view</Icon>,
      route: "/manage-discount/details/:id",
      component: <DiscountDetails />,
    },
    {
      name: "Otp Verify",
      key: "otp-verify",
      icon: <Icon fontSize="small">list_alt</Icon>,
      route: "/otp-verify",
      component: <VerifyOtp />,
    },
    {
      name: "Profile Setup",
      key: "profile-setup",
      icon: <Icon fontSize="small">list_alt</Icon>,
      route: "/authentication/profile-setup",
      component: <ProfileSetup />,
    },
    {
      name: "Edit Profile",
      key: "edit-profile",
      icon: <Icon fontSize="small">list_alt</Icon>,
      route: "/edit-profile",
      component: <EditProfile />,
    },
    {
      name: "Forgot Password",
      key: "forgot-password",
      icon: <Icon fontSize="small">list_alt</Icon>,
      route: "/authentication/forgot-password",
      component: <ForgotPassword />,
    },
    {
      name: "Reset Password",
      key: "reset-password",
      icon: <Icon fontSize="small">list_alt</Icon>,
      route: "/authentication/reset-password",
      component: <ResetPassword />,
    },
    {
      name: "Quote Chat",
      key: "quote-chat",
      icon: <Icon fontSize="small">list_alt</Icon>,
      route: "/quote-chat",
      component: <QuoteChat />,
    },
    {
      name: "Agreement",
      key: "agreement",
      icon: <Icon fontSize="small">list_alt</Icon>,
      route: "/agreement",
      component: <Agreement />,
    },
    {
      name: "Privacy Policy",
      key: "privacyPolicy",
      icon: <Icon fontSize="small">list_alt</Icon>,
      route: "/privacy-policy",
      component: <PrivacyPolicy />,
    },
    {
      name: "Terms",
      key: "terms",
      icon: <Icon fontSize="small">list_alt</Icon>,
      route: "/terms",
      component: <Terms />,
    },
    {
      name: "About",
      key: "about",
      icon: <Icon fontSize="small">list_alt</Icon>,
      route: "/about",
      component: <About />,
    },
  ];

  return routes;
};

export default GetAllRoutes;
